import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

import classes from './styles/api-keys-table.module.scss';

export type SortIconState = 'none' | 'asc' | 'desc';

interface SortIconProps {
  state: SortIconState;
}

/**
 * `sort-vertical-02` glyph from the design. Inherits color via `currentColor`
 * and rotates 180deg for ascending so the arrow points up.
 */
export const SortIcon: FunctionComponent<SortIconProps> = ({ state }) => (
  <svg
    aria-hidden="true"
    className={classnames(classes.sortIcon, {
      [classes.sortIconActive]: state !== 'none',
      [classes.sortIconAscending]: state === 'asc',
    })}
    fill="none"
    focusable="false"
    height="9"
    viewBox="0 0 14.3333 9"
    width="13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.12764 0.918213H13.8333M8.12764 4.12806H12.2031M8.12764 7.33792H10.5729M3.03709
        0.5V8.5M5.67107 6.05448L3.03709 8.5L0.500001 6.05448"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
